export const CROPPER_INVALID_SIZE = 'CROPPER_INVALID_SIZE';
export const DEFAULT_MIN_THUMBNAIL_WIDTH = 1280;
export const DEFAULT_MIN_THUMBNAIL_HEIGHT = 720;
export const DEFAULT_STANDARD_CROP_HEIGHT = 168;
export const DEFAULT_STANDARD_CROP_WIDTH = 300;
export const DEFAULT_REDUCED_CROP_SIZE = 120;
export const DEFAULT_REDUCED_PREVIEW_SIZE = 150;